<div class="messages-container" *ngIf="errorMessage">{{errorMessage}}</div>

<aumico-accept-invitation
    *ngIf="showMetaInformationForm; else showPassword"
    [organization]="organizationName"
    [supportedLocales]="supportedLocales"
    (emitPersonalMetaInformation)="onPersonalInformationEmitted($event)"
></aumico-accept-invitation>
<ng-template #showPassword>
    <aumico-users-reset-password-page
        [showTermsAndSubscriptionBoxes]="true"
        (resendVerificationMail)="onResendVerificationMail($event)"
        (resetPasswordSuccess)="onSetOrResetPasswordSuccess()"
        (passwordSet)="onPasswordReset($event)"
        (privacyPolicyClick)="redirectToPrivacyPolicy()"
    ></aumico-users-reset-password-page>
</ng-template>
